
import React, { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';


const UserGuidePage = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };
  return (
    <div>
          <div className="row my-2">
          <div style={{float: 'left'}}>
            <h5 style={{color:'#0E0A65' }}><img src='/assets/icons/book.svg' alt=""  style={{width: '20px', marginRight: '10px'}}  /> User Guide</h5>
          </div>
        </div>
        <hr/>


        <div className="card shadow mb-1 my-2">
        <Accordion className="mx-1 my-2 custom-accordion-button">
        <Accordion.Button
          as={Nav.Link}
          variant="link"
          eventKey="0"
          onClick={toggleNavbar}
        >


          <div className='header-cont' >
          <div>
          <span className="m-2 card-heading-2">About Threat Intelligence</span>
          </div>
          <div>{collapsed ? <KeyboardArrowUpIcon /> : <ExpandMoreIcon /> }</div>
          </div>
        </Accordion.Button>

        <Accordion.Body eventKey="0">
  
            <div className="card-body p-4">
              <div id="platfromtabcontent">

                <h6 id="h61" className='card-text-1'><b>Introduction:</b></h6>
                <p className="card-text">
                <b>Threat intelligence </b> 
                 involves the collection, analysis, and interpretation of data to identify and understand potential cybersecurity threats. It provides insights into the tactics, techniques, and procedures used by adversaries, empowering organizations to proactively defend against cyber attacks.
                 </p>
                    
                   </div>
                </div>
      
        </Accordion.Body>
      </Accordion>
        </div>
         
        
    </div>
  )
}

export default UserGuidePage
